var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ed-code--toolbar"},[_c('ed-form',{attrs:{"form-desc":_vm.formDesc,"inline":"","size":"mini"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }